import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FrmlaExperience from "@/pages/FrmlaExperience";
import IntakePage from "@/pages/IntakePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FrmlaExperience />} />
          <Route path="/intake" element={<IntakePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
